export default __webpack_public_path__ + "static/media/placeholder_portfolio03-it-web.57e4921e.png";